<nav class="navbar" data-node-id="1:2951">
  <div class="navbar-content">
    <!-- Logo -->
    <div
      class="logo-container"
      [class.logo-hidden]="isMobileSearchOpen()"
      data-node-id="I1:2951;1:16272"
      (click)="onLogoClick()"
    >
      <img [src]="logoUrl" alt="GivingSpace" class="logo" [class.logo-mobile]="true" />
    </div>

    <!-- Mobile Actions (visible only on mobile) -->
    <div
      class="mobile-actions"
      data-node-id="2435:117587"
      [class.stretch-width]="isMobileSearchOpen()"
    >
      <div class="mobile-search-wrapper">
        <!-- Search Icon Button -->
        @if (!isMobileSearchOpen()) {
          <button class="mobile-search-btn" (click)="toggleMobileSearch()" aria-label="Search">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
              <path
                d="M16 16L21 21"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
        }

        <!-- Mobile Search Field (replaces search icon) -->
        @if (isMobileSearchOpen()) {
          <div class="mobile-search-container">
            <div class="mobile-search-field">
              <input
                #mobileSearchInput
                type="text"
                class="mobile-search-input"
                [value]="mobileSearchValue()"
                [placeholder]="'nav.search.placeholder' | translateLang"
                (input)="onMobileSearchInput($event)"
                (focus)="onMobileSearchFocus()"
                (blur)="onMobileSearchBlur()"
                (keypress)="onMobileSearchKeyPress($event)"
                autofocus
              />
              @if (mobileSearchValue().length > 0) {
                <button class="mobile-clear-search-btn" (click)="clearMobileSearch()">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" />
                  </svg>
                </button>
              } @else {
                <svg
                  class="mobile-search-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.5" />
                  <path
                    d="M11 11L14 14"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              }
            </div>

            <!-- Minimum characters note -->
            @if (showMobileMinCharactersNote()) {
              <div class="mobile-search-note">
                {{ 'nav.search.minimum_characters' | translateLang }}
              </div>
            }

            <!-- No results message -->
            @if (showMobileNoResults()) {
              <div class="mobile-search-note">
                {{ 'nav.search.no_results_found' | translateLang }}
              </div>
            }

            <!-- Search recommendations dropdown -->
            @if (showMobileRecommendations()) {
              <div class="mobile-search-recommendations-dropdown">
                @if (searchRecommendations().charities.length > 0) {
                  <div class="recommendations-section">
                    <h3 class="recommendations-heading">
                      {{ 'nav.search.charities' | translateLang }}
                    </h3>
                    <div class="recommendations-list">
                      @for (charity of searchRecommendations().charities; track charity.uuid) {
                        <div
                          class="recommendation-item"
                          (click)="onMobileRecommendationClick(charity, 'charity')"
                        >
                          <span>{{ charity.name }}</span>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (searchRecommendations().projects.length > 0) {
                  <div class="recommendations-section">
                    <h3 class="recommendations-heading">
                      {{ 'nav.search.projects' | translateLang }}
                    </h3>
                    <div class="recommendations-list">
                      @for (project of searchRecommendations().projects; track project.uuid) {
                        <div
                          class="recommendation-item"
                          (click)="onMobileRecommendationClick(project, 'project')"
                        >
                          <span>{{ project.name }}</span>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>

      <app-language-switcher
        class="mobile-language-switcher"
        [class.lang-dropdown-open]="isLangDropdownOpen"
        [class.lang-dropdown-close]="!isLangDropdownOpen"
        (langDropdownOpen)="isLangDropdownOpen = $event"
      >
      </app-language-switcher>

      <div class="mobile-menu-wrapper">
        <button class="mobile-menu-btn" (click)="toggleMobileMenu()" aria-label="Menu">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 10H30M6 18H30M6 26H30"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </button>

        <!-- Mobile Menu Dropdown (opens below burger button) -->
        @if (isMobileMenuOpen()) {
          <div
            class="mobile-menu-dropdown"
            [attr.data-node-id]="(isAuthenticated$ | async) ? '2628:161157' : '2435:112109'"
            (click)="$event.stopPropagation()"
          >
            <div class="mobile-menu-dropdown-content">
              <!-- Profile Section (authenticated only) -->
              @if (isAuthenticated$ | async) {
                <div class="mobile-menu-profile">
                  <img
                    [src]="profilePictureUrl"
                    alt="Profile"
                    class="mobile-menu-profile-avatar"
                    (error)="onImageError($event)"
                  />
                  <div class="mobile-menu-profile-name">
                    <p>{{ userFullName || 'User' }}</p>
                  </div>
                </div>
                <div class="mobile-menu-divider"></div>
              }

              <!-- Manage My Fund (visible for Portal and Portal+GS users with funds) -->
              @if ((isAuthenticated$ | async) && hasPortalAccess() && hasFunds()) {
                <button class="mobile-menu-manage-fund-btn" (click)="toggleFundManagement()">
                  <span>{{ 'nav.menu.manage_my_fund' | translateLang }}</span>
                  <svg
                    class="mobile-menu-manage-fund-icon"
                    [class.rotated]="isFundManagementOpen()"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 6L8 10L12 6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>

                <!-- Fund Management Submenu -->
                @if (isFundManagementOpen()) {
                  <div class="mobile-menu-fund-submenu">
                    @for (item of fundManagementItems(); track item.id) {
                      @if (item.children?.length) {
                        <!-- Expandable item (e.g. Grant, Distribute) -->
                        <div class="mobile-menu-fund-link mobile-menu-fund-link--expandable">
                          <a
                            [routerLink]="item.data"
                            class="mobile-menu-fund-link-label"
                            (click)="closeMobileMenu()"
                            >{{ item.label | translateLang }}</a
                          >
                          <button
                            class="mobile-menu-fund-expand-btn"
                            (click)="toggleMobileItem(item.id)"
                            aria-label="Expand submenu"
                          >
                            <svg
                              class="mobile-menu-fund-expand-icon"
                              [class.rotated]="expandedMobileItemId() === item.id"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4 6L8 10L12 6"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                        @if (expandedMobileItemId() === item.id) {
                          @for (child of item.children!; track child.id) {
                            <a
                              [routerLink]="child.data"
                              [queryParams]="child.queryParams"
                              class="mobile-menu-fund-link mobile-menu-fund-link--child"
                              (click)="closeMobileMenu()"
                            >
                              {{ child.label | translateLang }}
                            </a>
                          }
                        }
                      } @else {
                        <a
                          [routerLink]="item.data"
                          class="mobile-menu-fund-link"
                          (click)="closeMobileMenu()"
                        >
                          {{ item.label | translateLang }}
                        </a>
                      }
                    }
                  </div>
                }
              }

              <!-- Navigation Links -->
              <div class="mobile-menu-links">
                <a
                  [routerLink]="AppRoutes.ABOUT"
                  class="mobile-menu-link"
                  (click)="closeMobileMenu()"
                >
                  {{ 'nav.menu.about' | translateLang }}
                </a>
                <a
                  [routerLink]="AppRoutes.ORGANIZATIONS"
                  class="mobile-menu-link"
                  (click)="closeMobileMenu()"
                >
                  {{ 'nav.menu.explore_charities' | translateLang }}
                </a>
                <a
                  [routerLink]="AppRoutes.PROJECTS"
                  class="mobile-menu-link"
                  (click)="closeMobileMenu()"
                >
                  {{ 'nav.menu.discover_projects' | translateLang }}
                </a>

                <a
                  [routerLink]="AppRoutes.CONTACT"
                  class="mobile-menu-link"
                  (click)="closeMobileMenu()"
                >
                  {{ 'nav.menu.contact_us' | translateLang }}
                </a>
              </div>

              <!-- Auth Actions -->
              @if (isAuthenticated$ | async) {
                <div class="mobile-menu-divider"></div>
                <div class="mobile-menu-actions">
                  <button
                    class="mobile-menu-action-btn"
                    (click)="onSettingsClick(); closeMobileMenu()"
                  >
                    <svg
                      class="mobile-menu-action-icon"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.6055 1.99841C6.60548 1.86601 6.55272 1.73902 6.45908 1.64538C6.36539 1.5518 6.23849 1.49891 6.10606 1.49891H5.88633C5.7539 1.49891 5.62701 1.5518 5.53331 1.64538C5.43968 1.73902 5.38691 1.86601 5.38682 1.99841V2.08923C5.38654 2.35207 5.31693 2.61021 5.18541 2.83777C5.05407 3.065 4.86471 3.25274 4.63755 3.38416L4.63826 3.38488L4.42369 3.51014L4.42222 3.51088C4.19442 3.64238 3.93598 3.7115 3.67295 3.71155C3.41522 3.71155 3.16202 3.64455 2.93761 3.51819V3.51892L2.8629 3.48113C2.85806 3.47855 2.85299 3.47582 2.84825 3.47308C2.73364 3.40456 2.59737 3.38661 2.46958 3.42328C2.37371 3.45141 2.28815 3.50973 2.22349 3.59062L2.16636 3.67296L2.05651 3.84338C1.99078 3.96035 1.97259 4.09878 2.00669 4.22882C2.03235 4.31968 2.08637 4.39953 2.15977 4.45668L2.23961 4.50453L2.26597 4.52139L2.33878 4.57076C2.55249 4.70578 2.72798 4.89019 2.85497 5.10853C2.98395 5.33219 3.05626 5.58431 3.05784 5.84091V6.11152C3.05889 6.37816 2.99024 6.64043 2.86113 6.87445C2.73336 7.10609 2.54576 7.30395 2.32017 7.44333L2.24619 7.48875L2.23961 7.49314C2.12507 7.56196 2.04089 7.67348 2.00669 7.80385C1.97266 7.93393 1.99069 8.07235 2.05651 8.18933L2.16636 8.35898L2.22349 8.44131C2.28815 8.52225 2.37366 8.58052 2.46958 8.60865C2.59742 8.64532 2.73359 8.62742 2.84825 8.55885C2.85304 8.55611 2.85801 8.55338 2.8629 8.55069L2.93761 8.51205C3.16187 8.38678 3.4155 8.32038 3.67295 8.32038C3.89799 8.32044 4.11948 8.37615 4.31755 8.48245L4.42222 8.53182L4.42369 8.53256L4.63682 8.65631C4.86417 8.78773 5.05368 8.97665 5.18541 9.20419C5.31696 9.43175 5.38654 9.69006 5.38682 9.95345V10.0443C5.38682 10.1761 5.4396 10.3028 5.53331 10.3966C5.62703 10.4903 5.75383 10.5431 5.88633 10.5431H6.10606C6.23857 10.5431 6.36536 10.4903 6.45908 10.3966C6.5528 10.3028 6.60558 10.1761 6.60558 10.0443V9.95345L6.60923 9.85461C6.62452 9.6261 6.69191 9.40325 6.80698 9.20419C6.93853 8.97665 7.12804 8.78773 7.35539 8.65631L7.56868 8.53256L7.57015 8.53182C7.79441 8.40028 8.04803 8.32044 8.30548 8.32038C8.56179 8.32038 8.81539 8.38705 9.03961 8.51205H9.04035L9.11506 8.55069L9.12915 8.55885C9.24381 8.62742 9.37998 8.64532 9.50782 8.60865C9.60374 8.58052 9.68925 8.52225 9.75391 8.44131L9.87301 8.18933L9.87522 8.18494C9.94108 8.06791 9.95935 7.92943 9.92515 7.79929V7.79854L9.86802 7.76646C9.86363 7.7639 9.85918 7.76124 9.85485 7.75848C9.62509 7.61891 9.43544 7.42094 9.30774 7.18445C9.17964 6.94043 9.11099 6.67816 9.11204 6.41152V6.11742C9.11137 5.85042 9.18002 5.58851 9.30774 5.355C9.43544 5.11864 9.6251 4.92091 9.85485 4.78142L9.92624 4.74315L9.93282 4.73948L9.93208 4.73875C10.0466 4.67071 10.1308 4.55914 10.165 4.42882C10.1991 4.29874 10.1811 4.16025 10.115 4.04328V4.04254L9.99871 3.87224L9.94083 3.79063C9.87646 3.71014 9.79137 3.65227 9.69619 3.62481C9.6271 3.60554 9.55458 3.60144 9.48368 3.6127C9.41278 3.62396 9.34513 3.65028 9.28555 3.6898C9.28075 3.69253 9.27581 3.69527 9.27101 3.69805L9.19555 3.73669L9.19481 3.73596C8.97022 3.86135 8.7171 3.92655 8.46021 3.92655C8.20332 3.92655 7.95019 3.86135 7.72561 3.73596L7.71024 3.72744L7.71097 3.72671L7.4964 3.60071V3.59998C7.26959 3.46859 7.08073 3.28008 6.95022 3.05377C6.81863 2.82621 6.74896 2.56807 6.74869 2.30523L6.7444 2.21294L6.74366 2.20342L6.7444 2.1946L6.74293 2.08923L6.7444 1.99841H6.60558H6.6055ZM7.60531 2.08851L7.60971 2.15369C7.61836 2.21823 7.63921 2.28077 7.67103 2.33753C7.70294 2.39449 7.74489 2.44423 7.79507 2.484L7.85506 2.52563L7.85653 2.52637L8.06696 2.64515C8.14561 2.68896 8.23177 2.71248 8.31958 2.71248C8.40702 2.71248 8.49329 2.68891 8.57204 2.64515C8.57646 2.64234 8.58213 2.63978 8.58656 2.63708L8.66128 2.59754C9.00018 2.40588 9.40235 2.35439 9.78056 2.45545C10.1641 2.55805 10.4919 2.80909 10.691 3.15271L10.8009 3.35741V3.35813C10.999 3.70206 11.0523 4.09556 10.951 4.47906C10.8498 4.86275 10.5987 5.19549 10.2536 5.39453L10.2461 5.3938L10.1857 5.43554L10.1783 5.44034L10.1776 5.43961C10.1017 5.48342 10.0389 5.54198 9.99025 5.61304C9.94138 5.68438 9.90817 5.76621 9.90838 5.84926V6.11926C9.90822 6.20222 9.94138 6.28394 9.99025 6.35546C10.0386 6.42444 10.1009 6.48177 10.1761 6.52378L10.2384 6.56173C10.2444 6.56444 10.2503 6.56777 10.2563 6.57055C10.5987 6.76952 10.8497 7.10167 10.951 7.48498C11.0516 7.86463 10.9989 8.25418 10.8031 8.5963L10.8038 8.59703L10.6946 8.80598L10.691 8.81226C10.4919 9.15586 10.1641 9.40645 9.78056 9.50905C9.40223 9.61005 9.00024 9.55862 8.66128 9.36696V9.36769L8.58656 9.32742C8.58213 9.32473 8.57646 9.32216 8.57204 9.31935C8.49334 9.27559 8.40702 9.25202 8.31958 9.25202C8.23177 9.25202 8.14561 9.27555 8.06696 9.31935L7.85653 9.43813L7.85506 9.43886C7.77679 9.48286 7.71003 9.54285 7.65977 9.61447C7.60949 9.68528 7.57776 9.76651 7.57531 9.85419V9.95345C7.57531 10.3161 7.43199 10.6647 7.17837 10.9183C6.92475 11.1719 6.57612 11.3153 6.21343 11.3153H5.87896C5.51627 11.3153 5.16764 11.1719 4.91402 10.9183C4.6604 10.6647 4.51708 10.3161 4.51708 9.95345V9.85419L4.51267 9.78901C4.50408 9.72423 4.48329 9.66149 4.45147 9.60447C4.41139 9.53156 4.35319 9.47085 4.28231 9.42713L4.28084 9.42639L4.07021 9.30685L4.00161 9.2741C3.92866 9.24318 3.84878 9.22702 3.76794 9.22702C3.68537 9.22702 3.60378 9.24318 3.52846 9.28185C3.52404 9.28455 3.51838 9.28712 3.51395 9.28982L3.43924 9.32742L3.43851 9.32669C3.09981 9.51814 2.69806 9.57015 2.31932 9.46905C1.93584 9.36645 1.60808 9.11586 1.40899 8.77226L1.29914 8.56683V8.56609C1.10103 8.22217 1.04772 7.82827 1.14903 7.44497C1.2495 7.06477 1.50027 6.73617 1.84205 6.53681L1.92191 6.48615L1.92923 6.48135L1.98576 6.44361C2.04535 6.39956 2.09496 6.34121 2.13133 6.27371C2.17604 6.19788 2.20181 6.11072 2.20155 6.02201V5.84926L2.19793 5.78409C2.18984 5.71975 2.16812 5.65747 2.1345 5.60197C2.09189 5.53821 2.03449 5.48538 1.96743 5.44761C1.95783 5.44259 1.94779 5.43737 1.93843 5.43188L1.8628 5.37959V5.37886C1.53201 5.18661 1.28588 4.87247 1.18149 4.50763C1.07886 4.12556 1.13062 3.73217 1.32359 3.39064V3.38991L1.43344 3.18517C1.63253 2.84155 1.96029 2.59053 2.34382 2.48793C2.72225 2.38695 3.12434 2.43864 3.46304 2.63004H3.46377L3.53849 2.66758C3.54291 2.67029 3.54858 2.67285 3.55301 2.67566C3.63162 2.71942 3.71794 2.74299 3.80538 2.74299C3.89282 2.74299 3.97914 2.71942 4.05775 2.67566L4.26831 2.55688L4.27005 2.55615C4.34819 2.51182 4.41482 2.45139 4.46497 2.37946C4.50381 2.32308 4.52932 2.25903 4.54005 2.1922L4.54446 2.12702V1.99914C4.5446 1.63647 4.68791 1.28784 4.94153 1.03422C5.19515 0.780602 5.54378 0.637253 5.90647 0.637253H6.24094C6.60364 0.637253 6.95226 0.780598 7.20588 1.03422C7.4595 1.28784 7.60281 1.63647 7.60295 1.99914V2.08851H7.60531Z"
                      />
                      <path
                        d="M6.99536 5.99634C6.99536 5.44449 6.54721 4.99708 5.99536 4.99658C5.44441 4.99658 5.00158 5.44441 4.99658 5.99634C4.99708 6.54815 5.44449 6.99536 5.99634 6.99536C6.54807 6.99523 6.99523 6.54807 6.99536 5.99634ZM7.99516 5.99634C7.99506 7.09999 7.09999 7.99506 5.99634 7.99516C4.89257 7.99506 3.99769 7.10008 3.99756 5.99634C3.99756 4.89249 4.89249 3.99756 5.99634 3.99756C7.10008 3.99769 7.99506 4.89257 7.99516 5.99634Z"
                      />
                    </svg>
                    <span>{{ 'nav.profile.settings' | translateLang }}</span>
                  </button>
                  <button
                    class="mobile-menu-action-btn"
                    (click)="onLogoutClick(); closeMobileMenu()"
                  >
                    <svg
                      class="mobile-menu-action-icon"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.375 7.875H1.875C1.67609 7.875 1.48532 7.79598 1.34467 7.65533C1.20402 7.51468 1.125 7.32391 1.125 7.125V1.875C1.125 1.67609 1.20402 1.48532 1.34467 1.34467C1.48532 1.20402 1.67609 1.125 1.875 1.125H3.375M6 6.375L7.875 4.5L6 2.625M7.875 4.5H3.375"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>{{ 'nav.profile.logout' | translateLang }}</span>
                  </button>
                </div>
              } @else {
                <app-button
                  [label]="'nav.actions.log_in' | translateLang"
                  variant="yellow"
                  (clicked)="onLoginClick(); closeMobileMenu()"
                >
                </app-button>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Menu Buttons (hidden on mobile) -->
    <div class="menu-buttons menu-buttons-extra-gap desktop-only" data-node-id="I1:2951;576:41546">
      <a [routerLink]="AppRoutes.ABOUT" class="menu-btn" data-node-id="I1:2951;576:41547">
        <p>{{ 'nav.menu.about' | translateLang }}</p>
      </a>
      <a [routerLink]="AppRoutes.ORGANIZATIONS" class="menu-btn" data-node-id="I1:2951;576:41548">
        <p>{{ 'nav.menu.explore_charities' | translateLang }}</p>
      </a>
      <a [routerLink]="AppRoutes.PROJECTS" class="menu-btn" data-node-id="I1:2951;576:41549">
        <p>{{ 'nav.menu.discover_projects' | translateLang }}</p>
      </a>

      <a [routerLink]="AppRoutes.CONTACT" class="menu-btn" data-node-id="I1:2951;576:41550">
        <p>{{ 'nav.menu.contact_us' | translateLang }}</p>
      </a>
    </div>

    <!-- Actions (hidden on mobile) -->
    <div class="nav-actions desktop-only" data-node-id="I1:2951;1:16280">
      <div class="search-field-wrapper">
        <div class="search-field" data-node-id="I1:2951;1:16281">
          <input
            type="text"
            class="search-input"
            [value]="searchValue()"
            [placeholder]="'nav.search.placeholder' | translate"
            (input)="onSearchInput($event)"
            (focus)="onSearchFocus()"
            (blur)="onSearchBlur()"
            (keypress)="onDesktopSearchKeyPress($event)"
          />
          @if (searchValue().length > 0) {
            <button class="clear-search-btn" (click)="clearSearch()" aria-label="Clear search">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 4L4 12M4 4L12 12"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          } @else {
            <svg
              class="search-icon"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              data-node-id="I1:2951;1:16281;301:22372"
            >
              <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.5" />
              <path
                d="M11 11L14 14"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          }
        </div>

        <!-- Minimum characters note -->
        @if (showMinCharactersNote()) {
          <div class="search-note">
            {{ 'nav.search.minimum_characters' | translateLang }}
          </div>
        }

        <!-- No results found -->
        @if (showNoResults()) {
          <div class="search-note">
            {{ 'nav.search.no_results_found' | translateLang }}
          </div>
        }

        <!-- Search recommendations dropdown -->
        @if (showRecommendations()) {
          <div class="search-recommendations-dropdown">
            @if (searchRecommendations().charities.length > 0) {
              <div class="recommendations-section">
                <h3 class="recommendations-heading">
                  {{ 'nav.search.charities' | translateLang }}
                </h3>
                <div class="recommendations-list">
                  @for (charity of searchRecommendations().charities; track charity.uuid) {
                    <div
                      class="recommendation-item"
                      (click)="onRecommendationClick(charity, 'charity')"
                    >
                      <span>{{ charity.name }}</span>
                    </div>
                  }
                </div>
              </div>
            }
            @if (searchRecommendations().projects.length > 0) {
              <div class="recommendations-section">
                <h3 class="recommendations-heading">{{ 'nav.search.projects' | translateLang }}</h3>
                <div class="recommendations-list">
                  @for (project of searchRecommendations().projects; track project.uuid) {
                    <div
                      class="recommendation-item"
                      (click)="onRecommendationClick(project, 'project')"
                    >
                      <span>{{ project.name }}</span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- Manage My Fund with Dropdown (visible for Portal and Portal+GS users with funds, not for GS-only or Portal Admin only) -->
      @if ((isAuthenticated$ | async) && hasPortalAccess() && hasFunds()) {
        <div
          #fundManagementWrapper
          class="fund-management-wrapper"
          (mouseenter)="onFundManagementMouseEnter()"
          (mouseleave)="onFundManagementMouseLeave()"
        >
          <div class="menu-btn fund-management-btn" [class.dropdown-open]="isFundDropdownOpen()">
            <p>{{ 'nav.menu.manage_my_fund' | translateLang }}</p>
            <app-caret-icon
              [isOpen]="isFundDropdownOpen()"
              [color]="'var(--colors-text-white, #ffffff)'"
              [customClass]="'fund-management-caret'"
            >
            </app-caret-icon>
          </div>

          <!-- Dropdown -->
          <div
            class="fund-management-dropdown"
            [class.fund-management-dropdown--above]="fundDropdownOpenAbove()"
          >
            <app-dropdown
              [items]="fundManagementItems()"
              [isOpen]="isFundDropdownOpen()"
              [maxHeight]="'400px'"
              [openAbove]="fundDropdownOpenAbove()"
              (itemSelected)="onFundMenuItemSelected($event)"
              (closed)="isFundDropdownOpen.set(false)"
            >
            </app-dropdown>
          </div>
        </div>
      }

      @if (isAuthenticated$ | async) {
        <div class="profile-wrapper">
          <div class="profile-avatar-container" (click)="toggleProfileSubmenu($event)">
            <img
              [src]="profilePictureUrl"
              alt="Profile"
              class="profile-avatar"
              (error)="onImageError($event)"
            />
          </div>

          <!-- Profile Submenu -->
          @if (isProfileSubmenuOpen()) {
            <div class="profile-submenu" (click)="$event.stopPropagation()">
              <div class="profile-submenu-header">
                <div class="profile-submenu-user">
                  <img
                    [src]="profilePictureUrl"
                    alt="Profile"
                    class="profile-submenu-avatar"
                    (error)="onImageError($event)"
                  />
                  <div class="profile-submenu-name">
                    <p>{{ userFullName || 'User' }}</p>
                  </div>
                </div>
                <div class="profile-submenu-divider"></div>
              </div>

              <div class="profile-submenu-item" (click)="onSettingsClick()">
                <svg
                  class="profile-submenu-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_446_35910)">
                    <path
                      d="M8.80743 2.66455C8.80731 2.48801 8.73696 2.31869 8.61211 2.19385C8.4872 2.06907 8.31799 1.99854 8.14141 1.99854H7.84844C7.67187 1.99854 7.50266 2.06907 7.37774 2.19385C7.2529 2.31869 7.18254 2.48801 7.18243 2.66455V2.78564C7.18206 3.13609 7.08924 3.48028 6.91387 3.78369C6.73875 4.08666 6.48629 4.33699 6.1834 4.51221L6.18438 4.51318L5.89825 4.68018L5.89629 4.68115C5.59256 4.8565 5.24798 4.94867 4.89727 4.94873C4.55363 4.94873 4.21603 4.8594 3.9168 4.69092V4.69189L3.81719 4.63818C3.81075 4.63474 3.80399 4.63109 3.79766 4.62744C3.64485 4.53941 3.46316 4.51548 3.29278 4.56104C3.16495 4.59522 3.05086 4.66631 2.96465 4.76416L2.88848 4.87061L2.742 5.12451C2.65438 5.27714 2.63012 5.45837 2.67559 5.62842C2.7098 5.75624 2.78183 5.86938 2.87969 5.95557L2.98614 6.03271L3.02129 6.05518L3.11504 6.11768C3.40332 6.29104 3.64397 6.53359 3.81329 6.82471C3.9886 7.12625 4.08169 7.46907 4.08379 7.81787V8.15869C4.08519 8.51088 3.99366 8.85724 3.81817 9.1626C3.64448 9.46478 3.39435 9.71527 3.09356 9.89111L2.99493 9.95166L2.98614 9.95752C2.83342 10.046 2.72118 10.1913 2.67559 10.3618C2.63021 10.5319 2.65426 10.7131 2.742 10.8657L2.88848 11.1187L2.96465 11.2251C3.05086 11.323 3.16488 11.394 3.29278 11.4282C3.46323 11.4738 3.64481 11.4499 3.79766 11.3618C3.80405 11.3581 3.81069 11.3545 3.81719 11.3511L3.9168 11.2974C4.21588 11.1291 4.55386 11.0405 4.89727 11.0405C5.20399 11.0406 5.50598 11.1116 5.78008 11.2466L5.89629 11.3091L5.89825 11.3101L6.18243 11.4751C6.48589 11.6503 6.73847 11.9022 6.91387 12.2056C7.08928 12.509 7.18207 12.8541 7.18243 13.2046V13.3247C7.18243 13.5014 7.2528 13.6705 7.37774 13.7954C7.50268 13.9203 7.67177 13.9907 7.84844 13.9907H8.14141C8.31809 13.9907 8.48717 13.9203 8.61211 13.7954C8.73706 13.6705 8.80743 13.5014 8.80743 13.3247V13.2046L8.81231 13.0728C8.83269 12.768 8.92255 12.471 9.07598 12.2056C9.25138 11.9022 9.50397 11.6503 9.80743 11.4751L10.0916 11.3101L10.0936 11.3091C10.3973 11.1337 10.7418 11.0406 11.0926 11.0405C11.4357 11.0405 11.7732 11.1294 12.0721 11.2974H12.0731L12.1727 11.3511L12.1922 11.3618C12.345 11.4499 12.5266 11.4738 12.6971 11.4282C12.8675 11.3826 13.0129 11.2713 13.1014 11.1187L13.244 10.8657L13.2469 10.8599C13.335 10.707 13.3598 10.5254 13.3143 10.355C13.2687 10.1845 13.1564 10.0391 13.0037 9.95068V9.94971L12.9246 9.90869C12.9181 9.9052 12.9115 9.90165 12.9051 9.89795C12.6001 9.72187 12.3472 9.46792 12.1717 9.1626C11.9962 8.85724 11.9047 8.51088 11.9061 8.15869V7.82861C11.9051 7.47722 11.9966 7.13135 12.1717 6.82666C12.3472 6.52151 12.6002 6.2683 12.9051 6.09229L12.9949 6.0376L13.0037 6.03271C13.1564 5.94428 13.2686 5.79886 13.3143 5.62842C13.3598 5.45794 13.335 5.2764 13.2469 5.12354V5.12256L13.1014 4.87061C13.0129 4.71805 12.8675 4.6066 12.6971 4.56104C12.5267 4.51548 12.345 4.53942 12.1922 4.62744C12.1859 4.63109 12.1791 4.63474 12.1727 4.63818L12.0731 4.69189L12.0721 4.69092C11.773 4.85913 11.4359 4.94873 11.0926 4.94873C10.7419 4.94867 10.3973 4.8565 10.0936 4.68115L10.0916 4.68018L9.80547 4.51318V4.51221C9.50291 4.33701 9.25097 4.08642 9.07598 3.78369C8.90061 3.48028 8.8078 3.13609 8.80743 2.78564V2.66455ZM10.1404 2.78467L10.1463 2.87158C10.1578 2.95764 10.1856 3.04102 10.2293 3.1167C10.2732 3.19265 10.332 3.25897 10.4012 3.31201L10.4734 3.36084L10.4754 3.36182L10.7596 3.52686C10.8608 3.58528 10.9757 3.61664 11.0926 3.6167C11.2094 3.6167 11.3244 3.58524 11.4256 3.52686C11.4321 3.52312 11.4395 3.51963 11.4461 3.51611L11.5457 3.46338C12.0002 3.20784 12.5365 3.13918 13.0408 3.27393C13.5523 3.4107 13.9893 3.74545 14.2547 4.20361L14.4012 4.45654V4.45752C14.6657 4.91608 14.7381 5.46074 14.6014 5.97217C14.4646 6.48367 14.1299 6.92066 13.6717 7.18604L13.6707 7.18506L13.5809 7.24072L13.5711 7.24658L13.5701 7.24561C13.4689 7.30423 13.3853 7.38931 13.327 7.49072C13.2685 7.59251 13.2376 7.70828 13.2381 7.82568V8.16357C13.2376 8.28097 13.2685 8.39675 13.327 8.49854C13.3848 8.59925 13.4679 8.68308 13.5682 8.7417L13.6512 8.78564C13.6579 8.78925 13.665 8.79352 13.6717 8.79736C14.1298 9.06269 14.4645 9.49889 14.6014 10.0103C14.7375 10.5195 14.6658 11.0617 14.4041 11.519L14.4051 11.52L14.2586 11.7798L14.2547 11.7866C13.9893 12.2448 13.5523 12.5786 13.0408 12.7153C12.5364 12.8501 12.0003 12.7815 11.5457 12.5259V12.5269L11.4461 12.4731C11.4395 12.4696 11.4321 12.4661 11.4256 12.4624C11.3244 12.4041 11.2094 12.3735 11.0926 12.3735C10.9757 12.3736 10.8608 12.404 10.7596 12.4624L10.4754 12.6284L10.4734 12.6294C10.3723 12.6878 10.2878 12.7714 10.2293 12.8726C10.1708 12.9737 10.1406 13.0887 10.1404 13.2056V13.3247C10.1404 13.8548 9.92933 14.363 9.5545 14.7378C9.17967 15.1126 8.67148 15.3237 8.14141 15.3237H7.84844C7.31838 15.3237 6.81018 15.1126 6.43536 14.7378C6.06053 14.363 5.84942 13.8548 5.84942 13.3247V13.2056L5.84356 13.1187C5.83211 13.0323 5.80443 12.9485 5.76055 12.8726C5.70208 12.7714 5.61759 12.6878 5.51641 12.6294L5.51446 12.6284L5.23028 12.4624L5.15215 12.4243C5.0716 12.3909 4.98504 12.3736 4.89727 12.3735C4.78049 12.3735 4.66544 12.4041 4.56426 12.4624C4.55779 12.4661 4.55035 12.4696 4.54376 12.4731L4.44415 12.5269L4.44317 12.5259C3.98877 12.7812 3.45314 12.8501 2.94903 12.7153C2.43753 12.5786 2.00054 12.2448 1.73516 11.7866L1.58868 11.5337V11.5327C1.32411 11.0741 1.25171 10.5286 1.38848 10.0171C1.52444 9.50881 1.85561 9.07489 2.30938 8.80908L2.40899 8.74951L2.41876 8.74365L2.49102 8.69482C2.56047 8.64149 2.61898 8.57495 2.6629 8.49854C2.72139 8.39675 2.75223 8.28096 2.75176 8.16357V7.82568L2.7459 7.73877C2.7341 7.653 2.70474 7.56995 2.66094 7.49463C2.60252 7.39428 2.51932 7.31051 2.41876 7.25244C2.40636 7.24529 2.39355 7.23792 2.38165 7.22998L2.28204 7.16357V7.1626C1.84267 6.89548 1.52159 6.46996 1.38848 5.97217C1.2518 5.46074 1.32416 4.91608 1.58868 4.45752V4.45654L1.73516 4.20361C2.00054 3.74545 2.43753 3.4107 2.94903 3.27393C3.45304 3.13926 3.98884 3.20818 4.44317 3.46338H4.44415L4.54376 3.51611C4.55035 3.51963 4.55779 3.52312 4.56426 3.52686C4.66549 3.58524 4.78041 3.6167 4.89727 3.6167C5.0141 3.61664 5.12909 3.58527 5.23028 3.52686L5.51446 3.36182L5.51641 3.36084C5.61759 3.30242 5.70208 3.21785 5.76055 3.1167C5.80424 3.04102 5.83208 2.95764 5.84356 2.87158L5.84942 2.78467V2.66455C5.84953 2.13462 6.06063 1.62619 6.43536 1.25146C6.81016 0.876801 7.31848 0.666504 7.84844 0.666504H8.14141C8.67138 0.666504 9.17969 0.876797 9.5545 1.25146C9.92922 1.62619 10.1403 2.13462 10.1404 2.66455V2.78467Z"
                    />
                    <path
                      d="M9.32715 7.99512C9.32715 7.25933 8.73087 6.66229 7.99512 6.66211C7.25922 6.66211 6.66211 7.25922 6.66211 7.99512C6.66229 8.73087 7.25933 9.32715 7.99512 9.32715C8.73076 9.32697 9.32697 8.73076 9.32715 7.99512ZM10.6602 7.99512C10.66 9.46666 9.46666 10.66 7.99512 10.6602C6.52343 10.6602 5.33025 9.46677 5.33008 7.99512C5.33008 6.52332 6.52332 5.33008 7.99512 5.33008C9.46677 5.33025 10.6602 6.52343 10.6602 7.99512Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_446_35910">
                      <rect width="15.9896" height="15.9896" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{{ 'nav.profile.settings' | translateLang }}</span>
              </div>

              <div class="profile-submenu-item" (click)="onLogoutClick()">
                <svg
                  class="profile-submenu-icon"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M4.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H4.5M8 8.5L10.5 6L8 3.5M10.5 6H4.5"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>{{ 'nav.profile.log_out' | translateLang }}</span>
              </div>
            </div>
          }
        </div>
      } @else {
        <app-button
          [label]="'nav.actions.log_in' | translateLang"
          variant="yellow"
          (clicked)="onLoginClick()"
          data-node-id="I1:2951;1:16282"
        >
        </app-button>
      }

      <app-language-switcher
        class="language-switcher-wrapper"
        data-node-id="I1:2951;1:16283"
      ></app-language-switcher>
    </div>
  </div>
</nav>
